
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.353 8.504a.667.667 0 011.118-.309l2.862 2.862-2.862-2.862a.667.667 0 00-1.118.31zm9.294.323a.666.666 0 00-1.118-.632l-2.862 2.862V3.333v7.724l2.861-2.861a.667.667 0 011.12.631zm-7.893-.915l2.18 2.18V3.332a1.067 1.067 0 112.133 0v6.758l2.179-2.179a1.067 1.067 0 011.508 1.509l-4 4a1.067 1.067 0 01-1.508 0l-4-4a1.067 1.067 0 011.508-1.509z","fill":"#EDAF0F"}})])
          )
        }
      }
    